"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    version: 0,
    completeEventsExpiryDays: 0,
    expiryDays: 0
};
//# sourceMappingURL=program.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/model-defaults/program.js
// module id = 595
// module chunks = 13